// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorGlobal-ErrorGlobal-errorContainer-d246afa5"};